var e=function(e){var t=this.__data__,a=t.delete(e);return this.size=t.size,a};export{e as default};
//# sourceMappingURL=_stackDelete.js.map
